const AwsLogo = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 128 128"
      fill="none"
      className="skill-icon"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M38.0891 77.4659L26.6891 82.3619L37.2481 86.8759L49.4891 82.3619L38.0891 77.4659ZM20.9511 83.5859L20.5691 105.62L37.2481 112.965V90.0889L20.9511 83.5859ZM55.2271 83.5859L40.1541 89.3249V110.9L55.2271 104.779V83.5859ZM73.2061 15.0349L61.7301 19.9309L72.3651 24.4459L84.6061 19.9309L73.2061 15.0349ZM57.2921 21.5379V43.5719L71.5231 47.7039L71.9821 27.6579L57.2921 21.5379ZM89.1201 22.7619L75.6541 28.4999V50.1519L89.1201 44.0309V22.7619ZM19.3061 46.0469L7.90713 50.9439L18.4651 55.4579L30.7061 50.9439L19.3061 46.0469ZM2.16813 52.1679L1.78613 74.2019L18.4651 81.5469V58.6709L2.16813 52.1679ZM36.4431 52.1679L21.3721 57.9059V79.4799L36.4431 73.3599V52.1679ZM56.0301 45.2309L44.6301 50.1279L55.1881 54.6419L67.4291 50.1279L56.0301 45.2309ZM38.8931 51.3519L38.5101 73.3869L55.1891 80.7319V57.8549L38.8931 51.3519ZM73.1681 51.3519L58.0961 57.0899V78.6659L73.1681 72.5449V51.3519ZM109.076 15.0349L97.6771 19.9309L108.236 24.4459L120.477 19.9309L109.076 15.0349ZM91.9391 21.1559L91.5571 43.1899L108.236 50.5339V27.6579L91.9391 21.1559ZM126.214 21.1559L111.143 26.8939V48.4689L126.214 42.3489V21.1559Z"
        fill="#00E96C"
      />
    </svg>
  );
};

export default AwsLogo;
